// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2471":"883fddb9","3406":"f4b3d3ae","8759":"2a37894b"}[chunkId] + ".chunk.css";
};